<template>
  <i class="fa fa-info-circle fa-sm pointer text-primary" @click="tip" title="Clique para saber mais"></i>
</template>

<script>
  export default {
    name: "Tooltip",
    props: ['msg'],
    methods: {
      tip() {
        this.$swal(this.msg);
      }
    }
  }
</script>
